import React from "react";
import { Send } from "lucide-react";
import { TELEGRAM_URL } from "../lib/api";

const FloatingTelegram = ({ url }) => {
    return (
        <a
            href={url || TELEGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-[#2AABEE] to-[#229ED9] shadow-2xl flex items-center justify-center hover:scale-110 active:scale-95 transition-transform"
            aria-label="Apri Telegram"
            data-testid="floating-telegram-btn"
        >
            <Send className="w-6 h-6 text-white -rotate-12" />
        </a>
    );
};

export default FloatingTelegram;
